<div [ngClass]="deviceService.ifMobile('title-mobile').orElse('title')">
    <ng-content></ng-content>
</div>
